import { createChildPath } from '../../../utils';
import generateAsyncRouteComponent from '../../../generateAsyncRouteComponent';

export default {
  path: createChildPath('delivery-addresses'),
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/DeliveryAddressesPage'),
  }),
};
